// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#000","menuActiveText":"#1890ff","subMenuActiveText":"#1890ff","menuBg":"#fff","menuHover":"#e6f7ff","subMenuBg":"#fff","subMenuHover":"#e6f7ff","sideBarWidth":"205px"};